module.exports = __webpack_public_path__ + "static/media/Apartment-1@2x.c148ec29.png";